import {post} from '@/utils/request';
import {smcanteenserver} from '@/utils/baseUrl';
import{sse_url} from '@/utils/baseUrl';

//食堂列表
export async function getEvaluateList(params) {
    return post(smcanteenserver+'/evaluate/getEvaluateList', params, true)
}
//食堂下拉
export async function getCanteenList(params) {
    return post(smcanteenserver+'/canteen/getCanteenList', params, true)
}

//
// //菜品保存
// export async function save(params) {
//     return post(smcanteenserver+'/canteen/save', params, true)
// }
//
// //食堂删除
// export async function remove(params) {
//     return post(smcanteenserver+'/canteen/delete', params, true)
// }
//
// //菜品详情
// export async function getDetail(params) {
//     return post(smcanteenserver+'/canteen/getDetail', params, true)
// }

